module.exports = __webpack_public_path__ + "img/rita.a3c22cd0.png";